import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34aa878c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 bg-black-primary bg-opacity-50 transition-opacity"
}
const _hoisted_2 = {
  key: 0,
  class: "fixed z-10 inset-0 overflow-y-auto"
}
const _hoisted_3 = { class: "flex items-center justify-center min-h-full p-4 text-center sm:p-0" }
const _hoisted_4 = { class: "relative bg-black-body rounded-lg p-10 text-sm text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full" }
const _hoisted_5 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_6 = { class: "text-red-primary m-0 mb-3 font-semibold text-md" }
const _hoisted_7 = { class: "text-white mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-text mb-2" }, " Rate the game and let the game developer know your feedback and any problems you may have encountered during testing. ", -1))
const _hoisted_9 = { class: "rating mb-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "★", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "★", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "★", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "★", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "★", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "★", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "★", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "★", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "★", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "★", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "★", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "★", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "★", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "★", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "★", -1))
const _hoisted_25 = { class: "col-sm-12 mb-5" }
const _hoisted_26 = { class: "flex justify-between items-center" }
const _hoisted_27 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.displayFeedbackModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.displayFeedbackModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h2", _hoisted_6, "Thank you, " + _toDisplayString(_ctx.username) + "!", 1),
                    _createElementVNode("p", _hoisted_7, " Done with testing and playing " + _toDisplayString(_ctx.title) + "? ", 1),
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          name: "stars",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rates) = $event)),
                          value: "1"
                        }, null, 512), [
                          [_vModelRadio, _ctx.rates]
                        ]),
                        _hoisted_10
                      ]),
                      _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          name: "stars",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rates) = $event)),
                          value: "2"
                        }, null, 512), [
                          [_vModelRadio, _ctx.rates]
                        ]),
                        _hoisted_11,
                        _hoisted_12
                      ]),
                      _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          name: "stars",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rates) = $event)),
                          value: "3"
                        }, null, 512), [
                          [_vModelRadio, _ctx.rates]
                        ]),
                        _hoisted_13,
                        _hoisted_14,
                        _hoisted_15
                      ]),
                      _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          name: "stars",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rates) = $event)),
                          value: "4"
                        }, null, 512), [
                          [_vModelRadio, _ctx.rates]
                        ]),
                        _hoisted_16,
                        _hoisted_17,
                        _hoisted_18,
                        _hoisted_19
                      ]),
                      _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          name: "stars",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rates) = $event)),
                          value: "5"
                        }, null, 512), [
                          [_vModelRadio, _ctx.rates]
                        ]),
                        _hoisted_20,
                        _hoisted_21,
                        _hoisted_22,
                        _hoisted_23,
                        _hoisted_24
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _withDirectives(_createElementVNode("textarea", {
                        rows: "5",
                        type: "text",
                        class: "bg-black-sidebar text-white p-2 w-full outline-none",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.message) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.message]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("a", {
                        type: "button",
                        class: "btn btn-default text-gray-text hover:text-gray-400 duration-200 transition-all",
                        href: "#",
                        onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.$emit('closeFeedbackModal','updateRating')), ["prevent"]))
                      }, "I'll do it later"),
                      _createElementVNode("button", {
                        class: "btn-primary float-end",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submitFeedback && _ctx.submitFeedback(...args))),
                        disabled: !_ctx.enableSubmitButton
                      }, _toDisplayString(_ctx.isSubmittingFeedback ? 'Submitting..' : 'Submit'), 9, _hoisted_27)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}